import { FunnelTemplate } from '@app/models/recruiting/funnel-template.model';
import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class NumberOfColumns extends Column {
    title = 'applicant-tracker.numberOfColumns';
    property = 'funnelTemplateStagesCount';
    sortField = 'funnelTemplateStagesCount';
    sortable = true;
    type: CellDisplay = CellDisplay.string;

    getDisplayPropertyValue(funnelTemplate: FunnelTemplate): string {
        // Adding 1 since we need to consider the applied column for each funnel template
        const columnCount = funnelTemplate.funnelTemplateStagesCount + 1;
        return columnCount.toString();
    }
}
